
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator';
import { SpeakersBlockLayout, SpeakersBlockListItemModel, SpeakersBlockSettingsModel } from 'fourwaves-shared';
import { RawHtml, OverlayElement } from 'fourwaves-shared/components';
import Simplebar from 'simplebar-vue';
import ContentBlockImage from '../ContentBlockImage.vue';

@Component({
  components: {
    OverlayElement,
    ContentBlockImage,
    RawHtml,
    Simplebar,
  },
})
export default class SpeakerBioModal extends Vue {
  @Prop({ type: Object, required: true }) readonly speaker!: SpeakersBlockListItemModel;
  @Prop({ type: Object, required: true }) readonly settings!: SpeakersBlockSettingsModel;

  @Ref() readonly overlayElement!: OverlayElement;

  isOverlayOpen: boolean = false;

  get aspectRatio(): number {
    return this.isCardLayout ? 3 / 2 : 1 / 1;
  }

  get isCardLayout(): boolean {
    return this.settings.layout === SpeakersBlockLayout.Card;
  }

  get rootClassNames(): Record<string, boolean> {
    return { '-has-image': this.hasImage };
  }

  get hasImage(): boolean {
    return this.speaker.image.url[this.$i18n.locale] || this.speaker.image.originalUrl[this.$i18n.locale];
  }

  public open(targetElement?: HTMLButtonElement | EventTarget | null) {
    if (targetElement) this.overlayElement.setTargetElement(targetElement);
    this.isOverlayOpen = true;
  }
}
